import { createSelector } from 'reselect'

const getState = state => state.MyPresentationsStore

const getData = state => getState(state).data

const getMyPresentationsList = createSelector(
  [getData],
  data => (!data ? [] : data.result.map(id => data.entities.presentations[id]))
)

const getPagination = state => getState(state).pagination

const getFilters = state => getState(state).filters

const getPresentationFromTheList = (state, id) => {
  const data = getData(state)
  if (!data) return null
  return data.entities.presentations[id] || null
}

const fetchingPresentations = state => getState(state).fetching

const isCreatingPresentation = state => getState(state).creating

const isPresentationUpdating = state => id => {
  const currentState = getState(state)
  return (
    (currentState.copying[id] && currentState.copying[id].pending) ||
    (currentState.settingToPublic[id] &&
      currentState.settingToPublic[id].pending) ||
    (currentState.settingToPrivate[id] &&
      currentState.settingToPrivate[id].pending) ||
    (currentState.deleting[id] && currentState.deleting[id].pending)
  )
}

export {
  getMyPresentationsList,
  getData,
  getPresentationFromTheList,
  isPresentationUpdating,
  getPagination,
  fetchingPresentations,
  isCreatingPresentation,
  getFilters
}
